import { createBrowserRouter } from 'react-router-dom'

import LoginLayout from '@utils/LoginLayout'
import DashboardLayout from '@utils/DashboardLayout'
import ProtectedRoutes from '@utils/ProtectedRoutes'

import Login from '@pages/login'

import Dashboard from '@pages/dashboard'

// users
import Users from '@pages/users'
import UsersForm from '@pages/users/form'

// customers
import Customers from '@pages/customers'
import CustomersForm from '@pages/customers/form'

// ombudsman
import OmbudsmanDashboard from '@pages/ombudsman'
import OmbudsmanCategories from '@pages/ombudsman/categories'
import OmbudsmanOrigins from '@pages/ombudsman/origins'
import OmbudsmanTypes from '@pages/ombudsman/types'
import Manifestations from '@pages/ombudsman/manifestations'
import ManifestationsCreate from '@pages/ombudsman/manifestations/create'
import ManifestationsEdit from '@pages/ombudsman/manifestations/edit'
import ManifestationsDetails from '@pages/ombudsman/manifestations/details'

// management
import ManagementContracts from '@pages/management/contracts'


const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <LoginLayout />,
            children: [
                {
                    path: '/',
                    element: <Login />,
                    index: true
                }
            ]
        },
        {
            element: <ProtectedRoutes />,
            children: [
                {
                    element: <DashboardLayout />,
                    children: [
                        {
                            path: 'dashboard',
                            element: <Dashboard />,
                            index: true
                        },


                        // users
                        {
                            path: 'users',
                            element: <Users />,
                            index: true
                        },
                        {
                            path: 'users/form/:co_user?',
                            element: <UsersForm />,
                            index: true
                        },


                        // customers
                        {
                            path: 'customers',
                            element: <Customers />,
                            index: true
                        },
                        {
                            path: 'customers/form/:co_customer?',
                            element: <CustomersForm />,
                            index: true
                        },


                        // ombudsman
                        {
                            path: 'ombudsman',
                            element: <OmbudsmanDashboard />,
                            index: true
                        },
                        {
                            path: 'ombudsman/categories/:category_id?',
                            element: <OmbudsmanCategories />,
                            index: true
                        },
                        {
                            path: 'ombudsman/origins/:origin_id?',
                            element: <OmbudsmanOrigins />,
                            index: true
                        },
                        {
                            path: 'ombudsman/types/:type_id?',
                            element: <OmbudsmanTypes />,
                            index: true
                        },
                        {
                            path: 'ombudsman/manifestations',
                            element: <Manifestations />,
                            index: true
                        },
                        {
                            path: 'ombudsman/manifestations/create',
                            element: <ManifestationsCreate />,
                            index: true
                        },
                        {
                            path: 'ombudsman/manifestations/edit/:manifestation_id?',
                            element: <ManifestationsEdit />,
                            index: true
                        },
                        {
                            path: 'ombudsman/manifestations/details/:manifestation_id?',
                            element: <ManifestationsDetails />,
                            index: true
                        },


                        // management
                        {
                            path: 'management/contracts',
                            element: <ManagementContracts />,
                            index: true
                        },
                    ],
                },
            ],
        }
    ]
)

export default router;
